export default "__VITE_ASSET__bc9b5c96__"